export default {
  data() {
    return {
      posteCanadaMainconfig: {
        searchFieldId: 'adresse-field',
        adresseKey: "adresse",
        completementDAdresseKey: "completementDAdresse",
        villeKey: "ville",
        codePostalKey: "codePostal",
        provinceKey: "province",
        paysKey: "pays"
      },
      additionalPosteCanadaConfigs: []
    }
  },
  watch: {
    "$route"() {
      this.setupAddressComplete()
    }
  },
  mounted() {
    this.setupAddressComplete()
  },
  methods: {
    setupAddressComplete() {
      // timeout nécessaire car sinon le querySelector par id du js addresscomplete se mélange avec les optimisations de Vuejs, pas trouvé mieux comme solution
      setTimeout(() => {
        if (window.pca) {
          this.addConfig(this.posteCanadaMainconfig)
          for (const posteCanadaConfig of this.additionalPosteCanadaConfigs) {
            this.addConfig(posteCanadaConfig)
          }

        } else {
          console.error("No AddressComplete (window.pca is undefined)")
        }
      }, 200)

    },
    addConfig(config) {
      if (!config.searchFieldId || !document.getElementById(config.searchFieldId)) {
        return
      }
      const fields = [{ element: config.searchFieldId, field: "Line1", mode: window.pca.fieldMode.SEARCH }]
      const options = {
        key: process.env.VUE_APP_ADDRESSCOMPLETE_KEY
      }
      const control = new window.pca.Address(fields, options)

      control.listen("populate", (address) => {
        this.$refs[config.adresseKey].setValue(address.Line1)
        this.$refs[config.completementDAdresseKey].setValue(address.Line2)
        this.$refs[config.villeKey].setValue(address.City)
        this.$refs[config.codePostalKey].setValue(address.PostalCode)
        this.$refs[config.provinceKey].setValueByCode(address.ProvinceCode)
        this.$refs[config.paysKey].setValueByCode(address.CountryIso2)

        if (this.afterPosteCanadaFill) {
          this.afterPosteCanadaFill(address)
        }
      })
    }
  }
}